module.exports = __webpack_public_path__ + "img/meal-success.adc30d16.svg";